import AwaitingImplementation from '@views/error-pages/AwaitingImplementation'

export default function Segments() {
	return <AwaitingImplementation />
}
